var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.75 10.25C32.25 10.25 9.75 32.75 9.75 60.25C9.75 87.75 32.25 110.25 59.75 110.25C87.25 110.25 109.75 87.75 109.75 60.25C109.75 32.75 87.25 10.25 59.75 10.25ZM59.75 100.25C37.7 100.25 19.75 82.3 19.75 60.25C19.75 38.2 37.7 20.25 59.75 20.25C81.8 20.25 99.75 38.2 99.75 60.25C99.75 82.3 81.8 100.25 59.75 100.25ZM82.7 38.15L49.75 71.1L36.8 58.2L29.75 65.25L49.75 85.25L89.75 45.25L82.7 38.15Z",
    fill: "#94E21D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.30e2a56f0a448d078a683ad936652183.svg";
export { ForwardRef as ReactComponent };